import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';

import { themes, Dialog } from 'libs/ui';
import { Toggle } from 'libs/form';
import { Content } from './privileged-set-form.styled';

const PrivilegedSetFormForm = (props) => {
  const { handleSubmit, invalid, working } = props;
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();

  const onChangeToggle = (event) => {
    const value = event.target.checked;
    setChecked(value);
  };

  /**
   * make action
   * @param {*} event
   */
  const submit = (values) => {
    return props.action(values);
  };

  return (
    <Dialog
      // w={450}
      id="dialog-privileged-set-form"
      title={'Заменить свободный проезд у выбранных записей'}
      align="justify"
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: handleSubmit(submit), theme: themes.blue, disabled: working | invalid, working },
      ]}
    >
      <Content>
        <form onSubmit={handleSubmit(submit)}>
          <Toggle name="is_privileged" value={checked || false} label={t('form.Свободный проезд')} onChange={onChangeToggle} checked={checked || false} type="toggle" />
        </form>
      </Content>
    </Dialog>
  );
};

export const PrivilegedSetForm = reduxForm({
  form: 'soPrivilegedSet',
  destroyOnUnmount: true,
  initialValues: { is_privileged: false },
})(PrivilegedSetFormForm);
